import axios from 'axios';

export async function getSmsRenewPass(cell) {
  try {
    const res = await axios({
      method: 'POST',
      url: process.env.REACT_APP_API_URL + '/api/users/users/request_password_reset/',
      data: {
        phone_number: cell,
      },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}
